import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React from "react";

const SearchCard = (props) => {
  const { page } = props;
  const { title, description } = page || {};

  const { breadcrumb: pageBreadcrumb } = page || {};
  let breadcrumb = pageBreadcrumb.map((b) => b.title);
  if (breadcrumb && breadcrumb.length > 3) {
    breadcrumb = [breadcrumb[0], breadcrumb[1], "...", breadcrumb[breadcrumb.length - 1]];
  }
  const subtitle = breadcrumb.join(` / `);

  // Elastic gives us contents we can't parse
  const pageWithoutContent = page;
  pageWithoutContent.contents = null;

  return (
    <div className="fr-card fr-enlarge-link" role="listitem">
      <div className="fr-card__body">
        <div className="fr-card__content">
          <h4 className="fr-card__title">
            <Link basic button page={pageWithoutContent} sx={{ wordBreak: "break-word" }}>
              {title}
            </Link>
          </h4>
          <div className="fr-card__end">{breadcrumb.length > 0 && <p className="fr-card__detail">{subtitle}</p>}</div>
          {description && <p className="fr-card__desc">{description}</p>}
        </div>
      </div>
    </div>
  );
};

SearchCard.propTypes = {
  page: PropTypes.shape(),
};

export default SearchCard;
